/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type GetTunneledMcpServerMetricsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetTunneledMcpServerMetricsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetTunneledMcpServerMetricsSecurity = {
  option1?: GetTunneledMcpServerMetricsSecurityOption1 | undefined;
  option2?: GetTunneledMcpServerMetricsSecurityOption2 | undefined;
};

export const Window = {
  Hour: "hour",
  Day: "day",
  Week: "week",
} as const;
export type Window = ClosedEnum<typeof Window>;

export type GetTunneledMcpServerMetricsRequest = {
  id: string;
  window?: Window | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetTunneledMcpServerMetricsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetTunneledMcpServerMetricsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetTunneledMcpServerMetricsSecurityOption1$Outbound,
    GetTunneledMcpServerMetricsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getTunneledMcpServerMetricsSecurityOption1ToJSON(
  getTunneledMcpServerMetricsSecurityOption1:
    GetTunneledMcpServerMetricsSecurityOption1,
): string {
  return JSON.stringify(
    GetTunneledMcpServerMetricsSecurityOption1$outboundSchema.parse(
      getTunneledMcpServerMetricsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetTunneledMcpServerMetricsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetTunneledMcpServerMetricsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetTunneledMcpServerMetricsSecurityOption2$Outbound,
    GetTunneledMcpServerMetricsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getTunneledMcpServerMetricsSecurityOption2ToJSON(
  getTunneledMcpServerMetricsSecurityOption2:
    GetTunneledMcpServerMetricsSecurityOption2,
): string {
  return JSON.stringify(
    GetTunneledMcpServerMetricsSecurityOption2$outboundSchema.parse(
      getTunneledMcpServerMetricsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetTunneledMcpServerMetricsSecurity$Outbound = {
  Option1?: GetTunneledMcpServerMetricsSecurityOption1$Outbound | undefined;
  Option2?: GetTunneledMcpServerMetricsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetTunneledMcpServerMetricsSecurity$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerMetricsSecurity$Outbound,
  GetTunneledMcpServerMetricsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetTunneledMcpServerMetricsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetTunneledMcpServerMetricsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getTunneledMcpServerMetricsSecurityToJSON(
  getTunneledMcpServerMetricsSecurity: GetTunneledMcpServerMetricsSecurity,
): string {
  return JSON.stringify(
    GetTunneledMcpServerMetricsSecurity$outboundSchema.parse(
      getTunneledMcpServerMetricsSecurity,
    ),
  );
}

/** @internal */
export const Window$outboundSchema: z.ZodMiniEnum<typeof Window> = z.enum(
  Window,
);

/** @internal */
export type GetTunneledMcpServerMetricsRequest$Outbound = {
  id: string;
  window: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetTunneledMcpServerMetricsRequest$outboundSchema: z.ZodMiniType<
  GetTunneledMcpServerMetricsRequest$Outbound,
  GetTunneledMcpServerMetricsRequest
> = z.pipe(
  z.object({
    id: z.string(),
    window: z._default(Window$outboundSchema, "day"),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getTunneledMcpServerMetricsRequestToJSON(
  getTunneledMcpServerMetricsRequest: GetTunneledMcpServerMetricsRequest,
): string {
  return JSON.stringify(
    GetTunneledMcpServerMetricsRequest$outboundSchema.parse(
      getTunneledMcpServerMetricsRequest,
    ),
  );
}
